// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_CalculateCommissionOverGrossSoldRemotelyResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /payroll/calculate_commission_over_gross_sold_remotely endpoint
 *
 * Calculates commissions for rules where employees are paid based on
 * revenue THEY specifically SOLD remotely (atendente attribution).
 *
 * `calculations` and `totals` are aggregate calculation outputs whose
 * shapes vary per rule_type; treated as opaque to preserve existing
 * wire shape until the calculation pipeline is itself contract-typed.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_CalculateCommissionOverGrossSoldRemotelyResponseDados {
rule_type: string
calculations: unknown[]
totals: Record<string, unknown>
success_count: number
error_count: number
}

export type Payroll_CalculateCommissionOverGrossSoldRemotelyResponse = ApiResponse<Payroll_CalculateCommissionOverGrossSoldRemotelyResponseDados>;

registerResponseContract('Payroll_CalculateCommissionOverGrossSoldRemotelyResponse', {
  rule_type:     { type: 'string',  required: true },
  calculations:  { type: 'array',   required: true },
  totals:        { type: 'object',  required: true },
  success_count: { type: 'number',  required: true },
  error_count:   { type: 'number',  required: true },
})
